import React, { useEffect, useMemo, useRef, useState } from "react";
import style from "../../../DashBoard/CompanyProfile.module.css";
import templateStyles from "../../../DashBoard/Templates/Templates.module.css"
import API from "../../../../ApiConfig"
import {
  BASE_URL,
  EXPORT_REQUESTS,
  GET_ALL_COMPANIES,
  GET_VERIFIER_REQUEST,
  GLOBAL_REQUESTS,
  SEND_FOLLOWUP_EMAILS,
  UPDATE_STATUS,
  USER_TOKEN,
  VIEW_LOA} from  "../../../../Utils/constant";

import { AuthConsole, convertDateFormat, parseBlobError, setDate } from "../../../../Utils/helper"
import cogoToast from "cogo-toast-react-17-fix";
import useRefreshToken from "../../../../Hooks/usegenerateToken"
import SlideUpWrapper from "../../../../components/Transitions/SlideUpWrapper";
import { useSelector } from "react-redux";
import ShimmerLoader from "../../../../components/ShimmerLoader";
import Pagination from "../Pagination";
import CustomDropDown from "../../../../components/CustomDropDown";
import ReactPortalModal from "../../../../components/ReactPortalModal";
import TopTitleBar from "../TopTitleBar";
import { useLocation, useNavigate } from "react-router-dom";
import PageSizeSelector from "../../../../Utils/PageSizeSelector";
import AnimatedLoader from "../../../../components/AnimationLoader";

const VerificationRequests = () => {
  useRefreshToken(BASE_URL + USER_TOKEN);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const Status = [
    "all_requests",
    "completed",
    "pending_on_issuer",
    "fnf_pending",
    "recovery_pending",
    "employee_absconding",
    "not_an_employee",
    "active_employee"
  ];
  const [dateRange, setDateRange] = useState({ startDate: "", endDate: "" });

  const [currentRecords, setCurrentRecords] = useState([]);
  const [docRequests, setDocRequests]=useState([])
  const [isOpen, setisOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);

  const [totalPages, setTotalPages] = useState(1);

  const [selectedUserids, setSelectedUserids] = useState([]);

  const [selectedValue, setSelectedValue] = useState("all_requests");

  const [companiesList, setCompaniesList] = useState([]);
  const [selectedSearchStatus, setSelectedSearchStatus]=useState("")
  const[loaPreview, setLoaPreview]=useState(null)
  const[LOALoading, setLOALoading]=useState(false)
  const [company, setCompany] = useState({
    "id": 0,
            "name": "Select Issuer",
            "issuers": [],
            "verifiers": []
  });
  const [verifierList, setVerifierList] = useState([]);
  const [verifiername, setVerifierName] = useState({
    "id": 0,
            "name": "Select Verifier",
            "issuers": [],
            "verifiers": []
  });
  const [sortBy, setSortBy]=useState({
    key:"created_at",
    direction:"desc"
  })
  const [OpenMenu, setOpenMenu] = useState(null);
  const [listData, setListData] = useState({});
  const User=useSelector(state=>state.User)


  const location=useLocation()
  console.log(location);
  

  const navigate=useNavigate()
  const[pageSize, setPageSize]=useState(10)
  // const getGlobalRequests = () => {

  //   setLoading(true);
  //   API.get(GLOBAL_REQUESTS , {
  //     params: {
  //       issuer_company_id:User.company_id,
  //       page: currentPage,
  //       status:selectedValue,
  //       sort_by:sortBy.key,
  //       search:search,
  //       sort_order:sortBy.direction
  //     },
  //   })
  //     .then((res) => {
  //       if (res.data.status == 200) {
  //         setLoading(false);
  //         setCurrentRecords(res.data.data.items);
  //         setTotalPages(res.data.data.total_pages);
  //       }
  //     })

  //     .catch((err) => {
  //       setLoading(false);
  //       console.log(err);
  //     });
  // };

  const handleDateChange = (field, e) => {
    setDateRange((prev) => ({ ...prev, [field]: e }));
  };
  const handleDownload = async (e) => {
    e.preventDefault();

    setLoading(true);
    if (dateRange.startDate !== "" && dateRange.endDate !== "") {
      const apiData = {
        issuer_company_id: company?.id,
        verifier_company_id: verifiername?.id,

        status: selectedValue,
        start_date: convertDateFormat(dateRange.startDate),
        end_date: convertDateFormat(dateRange.endDate),
      };

      API.post(EXPORT_REQUESTS, apiData, { responseType: "blob" })
        .then((res) => {
          if (res.status == 200) {
            setDateRange({ startDate: "", endDate: "" });
            setCompany([]);
            getGlobalRequests();
            const blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = url;
            link.download = `${dateRange.startDate}_to_${dateRange.endDate}.xlsx`;
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }
        })
        .catch(async (err) => {
          cogoToast.error(await parseBlobError(err));
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
      cogoToast.error("Enter Valid Start and End Date");
    }
  };
  const handleSearch = (e) => {
    setSearch(e);
    setCurrentPage(1)
  };
  // const getVerifierDocRequest = () => {
  //   setLoading(true);

  //   API.get(GET_VERIFIER_REQUEST + User.id)
  //     .then(res => {
  //       if (res.data.status == 200) {
  //         setLoading(false)
  //         setListData(res.data.data)
  //         setCurrentRecords(res.data.data)
  //       }
  //     })
  //     .catch(err => {
  //       setLoading(false)
  //       // console.log(err);

  //     })
  // }
  


  const getVerificationData=async()=>{
    try{
      setLoading(true)
      const [requestRes, docRequestRes]=await Promise.all([
        API.get(GLOBAL_REQUESTS,{
          params:{
            issuer_company_id: User.company_id,
            page: currentPage,
            status: selectedValue,
            sort_by: sortBy.key,
            search: search,
            sort_order: sortBy.direction,
            limit:pageSize
          }
        }),
        API.get(GET_VERIFIER_REQUEST+User.id)
      ])
      if(requestRes.data.status==200){
        setCurrentRecords(requestRes.data.data.items)
        setTotalPages(requestRes.data.data.total_pages)
      }
      if(docRequestRes.data.status==200){
        setDocRequests(docRequestRes.data.data)
      }
    }
    catch(err){
      cogoToast.error(err)
    }
    finally{
      setLoading(false)
    }

  }
  useEffect(()=>{
    const delayDebounce=setTimeout(()=>{
      // getGlobalRequests()
      // getVerifierDocRequest()
      getVerificationData()

    },700)
    return ()=>clearTimeout(delayDebounce)
  },[search,
    company,
    verifiername,
    selectedValue,
    dateRange,
    currentPage,
    sortBy,
    pageSize
  ])
  const issueMap = useMemo(() => {
    return (docRequests || [])
      .filter(doc => doc.status === 1)
      .reduce((acc, doc) => {
        acc[doc.employee_id] = doc;
        return acc;
      }, {});
  }, [docRequests])



  const mergedRequests = useMemo(() => {
    return (currentRecords || []).map(req => {
      const issue = issueMap[req.employee_id];
  
      return {
        ...req,
        hasIssue: !!issue,
        issueData: issue || null
      };
    });
  }, [currentRecords, issueMap])
  useEffect(() => {
    setCurrentPage(1);
  }, []);
  useEffect(()=>{
    if(location.state=="pending_requests")
    setSelectedValue("pending_on_issuer")
  },[location])
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };
  const FilterStatus = () => {
    const SearchStatus = ["FNF_PENDING", "RECOVERY_PENDING", "EMPLOYEE_ABSCONDING","PENDING_ON_ISSUER", "NOT_AN_EMPLOYEE","ACTIVE_EMPLOYEE","CLOSED"];

    const [issuerRemarks, setIssuerRemarks]=useState("")
    const [error, setError]=useState("")
    const handleStatusCheck = async () => {
      if(issuerRemarks==""){
        setError("Enter Remarks")
      }
      if(issuerRemarks.trim()==""){
        setError("Enter Valid Remarks")
      }
      else{
        setError("")
      setOpenMenu(false)
      await updateUserStatus(listData.id, selectedSearchStatus);
      setTimeout(() => setisOpen(false), 100);
      }
    };

    const updateUserStatus = (id, status) => {
      setLoading(true);
      API.put(`${UPDATE_STATUS}${id}`, { new_status: status, remarks:issuerRemarks })
        .then((res) => {
          if (res.data.status == 200) {
            setLoading(false);
            getVerificationData()
            cogoToast.success(res.data.message);
          }
        })
        .catch((err) => {
          cogoToast.error(err.response.data.message|| "Something Went wrong in Updating Status")
        })
        .finally(() => {
          setLoading(false);
        });
    };

    
    return (
      <>
      {error &&
      <div
      style={{
        backgroundColor: "#fee2e2",
        color: "#b91c1c",
        padding: "0.75rem 1rem",
        borderRadius: "8px",
        marginBottom: "1rem",
        fontWeight: "500",
        textAlign: "center",
      }}
    >
      {error}
    </div>
      }
        <div style={{ padding: "15px" }}>
           <CustomDropDown
                list={SearchStatus}
                selectedOption={selectedSearchStatus}
                onSelect={(e) => {setSelectedSearchStatus(e)}}
              />
              <textarea placeholder="Enter Remarks" onChange={(e)=>{setIssuerRemarks(e.target.value);setError("")}} style={{margin:"10px 0px", width:"90%", height:"200px", padding:"10px", border:"1px solid lightgray", borderRadius:"10px"}}/>
                <div style={{textAlign:"center"}}>
                <button className="btn btn-primary" onClick={()=>handleStatusCheck()}>Submit</button>
                </div>
        </div>
      </>
    );
  };
  const Dropdown = ({
    listType,
    list,
    selectedOption,
    label,
    onSelect,
    type,
  }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dialogBox = useRef(null);
    const handleToggle = () => {
      setIsOpen(!isOpen);
    };

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dialogBox.current && !dialogBox.current.contains(event.target)) {
          setIsOpen(false);
        }
      };
      document.addEventListener("click", handleClickOutside);
      return () => {
        document.removeEventListener("click", handleClickOutside);
      };
    }, []);
    const handleSelectItem = (item) => {
      onSelect(item, type);
      setIsOpen(false);
    };
    if (listType == 0) {
      return (
        <div
          className={dropdownStyle.letter}
          ref={dialogBox}
          style={{ width: "15rem", padding: "0px 15px" }}
        >
          <div
            className={dropdownStyle.lettertype}
            onClick={handleToggle}
            style={{ cursor: "pointer" }}
          >
            <div className={dropdownStyle.selectItem}>
              <p> {selectedOption?.name ? selectedOption.name : label}</p>
              {isOpen ? (
                <img
                  src="/chevrondown.svg"
                  style={{ transform: "rotate(180deg)" }}
                />
              ) : (
                <img src="/chevrondown.svg" />
              )}
            </div>
          </div>
          <div
            className={dropdownStyle.customDropdown}
            style={{ width: "inherit" }}
          >
            {isOpen && (
              <div
                className={dropdownStyle.dropdownOptions}
                style={{ maxHeight: "20rem", overflowY: "scroll" }}
              >
                {list.map((i) => (
                  <div
                    key={i.id}
                    className={dropdownStyle.dropdownList}
                    onClick={() => handleSelectItem(i)}
                  >
                    {i.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      );
    }
  };

  const handleAction = (index, element) => {
    setOpenMenu(OpenMenu == index ? null : index);
    setListData(element);
    setSelectedSearchStatus(element.status_description.trim()
    .replace(/\s+/g, "_") 
    .toUpperCase())
  };

  const sortList=(sort)=>{
    let direction = "asc";

    if (sortBy.key === sort && sortBy.direction === "asc") {
        direction = "desc";
    }
    const newSortBy = { key:sort, direction }
    setSortBy(newSortBy)
  }

  const handleNavigate=(holder_data)=>{
    const holderData={verifier_request_id:holder_data.id, document_id:holder_data.issuer_document_id}
    navigate("/dashboard/issueDocumentRequest", {state:{master_document_id:holder_data.master_document_id}})
    localStorage.setItem("holder_data",JSON.stringify(holderData))
  }
  const handlePageSize=(newSize)=>{
    setPageSize(newSize)
    setCurrentPage(1)
  }
  const handleLOAView=(id)=>{
      setLOALoading(true)
      API.get(VIEW_LOA+id)
      .then(res=>{
        if(res.status==200){
          setLOALoading(false)
          setLoaPreview(res.data.data.pdf_url)
        }
      })
      .catch(err=>{
        setLOALoading(false)
        setLoaPreview("")
        AuthConsole(err);
        
      })
    }
    const DocPreview = () => {
        var loading = {
          padding: "1rem",
          height: "10vh",
          width: "-webkit-fill-available",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }
        if (!loaPreview) {
          return (<div style={loading}>
            Error while generating PDF
          </div>)
        }
        else {
          return (
            <embed
            key={loaPreview}
              id="pdf-viewer"
              src={loaPreview + "#toolbar=0"}
              type="application/pdf"
              style={{width:"700px", height:"500px"}}
            />
          )
        }
      }
  return (
    <SlideUpWrapper direction="slide-left">
      <AnimatedLoader loadingText={"Getting Data.."} isOpen={LOALoading}/>
      <TopTitleBar isChild><h1 className="topTitleBarText"><span className="secondaryButton1">Verifier Requests</span></h1></TopTitleBar>
        <div className={style.searchContainer}>
          <div className="inputField2">
            <div className="input1">
              <div className="content1">
                <img
                  className="searchOutlineIcon1"
                  alt=""
                  src="/searchoutline.svg"
                />
                <input
                  value={search}
                  onChange={(e) => handleSearch(e.target.value)}
                  className="inputText1"
                  placeholder="Search"
                />
              </div>
            </div>
          </div>
          <div style={{ margin: "1rem" }}>
          <div className="exportRecords">
            <div style={{ margin: "0px 10px" }}>
              <CustomDropDown
                list={Status}
                selectedOption={selectedValue}
                onSelect={(e) => {setSelectedValue(e); setCurrentPage(1)}}
              />
            </div>
          </div>
          </div>
        </div>
      <div className="credentials-table">
        <table style={{ borderRadius: "10px", border:"1px solid lightgray" }}>
          <tr className="credentials-header bg-lgray">
            <th className="credentials-th">
              <div className="credentials-table-text">Search ID</div>
            </th>
            <th className="credentials-th" style={{cursor:"pointer"}} onClick={()=>sortList("notification_info_name")}>
              <div className="credentials-table-text">Candidate Name</div>
              <img className="chevronSortIcon" alt="" src="/chevronsort.svg" />
            </th>
            <th className="credentials-th" style={{cursor:"pointer"}} onClick={()=>sortList("employee_id")}>
              <div className="credentials-table-text">Emp Id</div>
              <img className="chevronSortIcon" alt="" src="/chevronsort.svg" />
            </th>
            <th className="credentials-th" style={{cursor:"pointer"}} onClick={()=>sortList("created_at")}>
              <div className="credentials-table-text">Raised On</div>
              <img className="chevronSortIcon" alt="" src="/chevronsort.svg" />
            </th>


            <th className="credentials-th" style={{cursor:"pointer"}} onClick={()=>sortList("master_document_name")}>
              <div className="credentials-table-text">Document Name</div>
              <img className="chevronSortIcon" alt="" src="/chevronsort.svg" />

            </th>

            <th className="credentials-th">
              <div className="credentials-table-text">Verifier</div>
            </th>

            <th className="credentials-th">
              <div className="credentials-table-text">On Behalf Of</div>
            </th>
            <th className="credentials-th" style={{cursor:"pointer"}} onClick={()=>sortList("updated_at")}>
              <div className="credentials-table-text">Responded On</div>
              <img className="chevronSortIcon" alt="" src="/chevronsort.svg" />
            </th>
            <th className="credentials-th" style={{cursor:"pointer"}} onClick={()=>sortList("status")}>
              <div className="credentials-table-text">Request Status</div>
              <img className="chevronSortIcon" alt="" src="/chevronsort.svg" />
            </th>
            <th className="credentials-th" style={{cursor:"pointer"}} onClick={()=>sortList("status")}>
              <div className="credentials-table-text">View Doc</div>
            </th>
            <th className="credentials-th">
              <div className="credentials-table-text">Action</div>
            </th>
          </tr>
          {loading ? (
            <>
              <tr className="credentials-tr">
                <td className="credentials-td">
                  <div className="credentials-table-text">
                    {" "}
                    <ShimmerLoader width="10rem" height="1.5rem" />
                  </div>
                </td>
                <td className="credentials-td">
                  <div className="credentials-table-text">
                    <ShimmerLoader width="7rem" height="1.5rem" />
                  </div>
                </td>
                <td className="credentials-td">
                  <div className="credentials-table-text">
                    {" "}
                    <ShimmerLoader width="7rem" height="1.5rem" />
                  </div>
                </td>
                <td className="credentials-td">
                  <div className="credentials-table-text">
                    {" "}
                    <ShimmerLoader width="7rem" height="1.5rem" />
                  </div>
                </td>
              </tr>
              <tr className="credentials-tr">
                <td className="credentials-td">
                  <div className="credentials-table-text">
                    {" "}
                    <ShimmerLoader width="10rem" height="1.5rem" />
                  </div>
                </td>
                <td className="credentials-td">
                  <div className="credentials-table-text">
                    <ShimmerLoader width="7rem" height="1.5rem" />
                  </div>
                </td>
                <td className="credentials-td">
                  <div className="credentials-table-text">
                    {" "}
                    <ShimmerLoader width="7rem" height="1.5rem" />
                  </div>
                </td>
                <td className="credentials-td">
                  <div className="credentials-table-text">
                    {" "}
                    <ShimmerLoader width="7rem" height="1.5rem" />
                  </div>
                </td>
              </tr>
            </>
          ) : mergedRequests.length === 0 ? (
            <tr className="credentials-tr">
              <td colSpan="6" className="credentials-td text-center">
                <div className="Data_List">No Requests</div>
              </td>
            </tr>
          ) : (
            <>
              {mergedRequests.map((i, index) => {
                return (
                  <tr
                    className="credentials-tr"
                    style={{ animationDelay: `${index * 0.1}s` }}
                  >
                    <td className="credentials-td" style={{textAlign:"center"}}>
                      <div
                        className="credentials-table-text1"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                          <div className="checkbox-wrapper-19">
                            <div className="round">

                          </div>
                        </div>
                        <div>{i.id}</div>
                      </div>
                    </td>
                    <td className="credentials-td">
                      <div
                        className="credentials-table-text1"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <div>{i.notification_info_name}</div>
                      </div>
                    </td>
                    <td className="credentials-td">
                      <div
                        className="credentials-table-text1"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <div>{i.employee_id?i.employee_id:"NA"}</div>
                      </div>
                    </td>
                    <td className="credentials-td">
                      <div className="credentials-table-text1">
                        {setDate(i.created_at)}
                      </div>
                    </td>
                    <td className="credentials-td">
                      <div className="credentials-table-text1">
                        {i.master_document_name}
                      </div>
                    </td>
                    <td className="credentials-td">
                      <div className="credentials-table-text1" style={{textAlign:"center"}}>
                        {i.verifier_company_name}
                      </div>
                    </td>
                    <td className="credentials-td">
                      <div className="credentials-table-text1" style={{textAlign:"center"}}>
                        {i.on_behalf_of_company_name}
                      </div>
                    </td>
                    <td className="credentials-td">
                      <div className="credentials-table-text1">
                        {setDate(i.updated_at)}
                      </div>
                    </td>
                    <td className="credentials-td Action-row">
                      <div
                        className={`credentials-table-text  ${
                          i?.status_description == "Completed" || i.status_description=="Pending On Holder" || i.status_description=="Rejected"
                            ? "Complete":i?.status_description=="Not An Employee"?"bg-gray-100 text-gray-700 border-gray-300":i?.status_description=="Active Employee"?"bg-green-100 text-green-700 border-green-300"
                            :i?.status_description=="Closed"?"Rejected": "Pending"
                        }`}
                        style={{ width: "7rem", height: "auto", textAlign:"center" }}
                      >
                        {(i.status_description=="Pending On Holder" || i.status_description=="Rejected")? "Completed":i.status_description.replace(/_/g, " ")}
                      </div>
                    </td>
                    <td className="credentials-td">
                                        {!i.holder_id&&  <div className="credertials-table-text" onClick={()=>handleLOAView(i.id)} style={{cursor:"pointer"}}>{i.loa_uploaded &&<img alt="" src="/eyeoutline.svg" />}</div>}
                                        </td>
                    <td className="credentials-td" style={{width:"3rem"}}>
                      {i.status_description =="Pending On Issuer" || i.status_description== "FNF Pending" || i.status_description=="Recovery Pending" || i.status_description=="Employee Absconding" || i.status_description=="Not An Employee" || i.status_description=="Active Employee" ? (
                        <div style={{display:"flex"}}>
                        <div
                          className="credentials-table-text"
                          onClick={() => handleAction(i.id, i)}
                          style={{cursor:"pointer"}}
                        >
                          <img src="/morevert.svg" alt="morevert.svg" />
                        </div>
                      {i.status==1 &&  <button className={"btn btn-primary"} onClick={() => handleNavigate(i)} disabled={i.status!==1}>Issue</button>}
                        </div>
                      ) : null}
                    </td>
                  </tr>
                );
              })}
            </>
          )}
        </table>
        <ReactPortalModal
          title={"Change Request Status"}
          isOpen={OpenMenu}
          onClose={() => setOpenMenu(null)}
          blockOutsideClick={true}
        >
          <FilterStatus />
        </ReactPortalModal>
        <ReactPortalModal
                title={"Document PREVIEW"}
                isOpen={loaPreview}
                onClose={()=>setLoaPreview(null)}
                >
                  <DocPreview/>
                </ReactPortalModal>

        <div style={{ margin: "10px" }}>
          <PageSizeSelector value={pageSize} onChange={handlePageSize}/>
          <Pagination
            nPages={totalPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            onPageChange={handlePageChange}
            loading={loading}
          />
        </div>
      </div>
    </SlideUpWrapper>
  );
};

export default VerificationRequests;